export default "__VITE_ASSET__DXlk2EYV__"